import React, { useState } from 'react';
interface EquipmentInformationProps {
  equipmentDetailsData: any;
}
const EquipmentInformation: React.FC<EquipmentInformationProps> = ({
  equipmentDetailsData,
}) => {
  //dateformat
  function formatDate(isoDate: string | Date) {
    const months = [
      'JAN',
      'FEB',
      'MAR',
      'APR',
      'MAY',
      'JUN',
      'JUL',
      'AUG',
      'SEP',
      'OCT',
      'NOV',
      'DEC',
    ];

    const date = new Date(isoDate);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }

  return (
    <section className="equipment_information">
      <div className="equipment_information-header">
        <h5>Equipment Information</h5>
      </div>
      <div className="equipment_information-content">
        <div className="equipment_information-content-data">
          <div className="equipment_information-content-data-item">
            <h5>Serial Number</h5>
            <h6>{equipmentDetailsData?.serialNumber || '-'}</h6>
          </div>

          <div className="equipment_information-content-data-item">
            <h5>Gateway No.</h5>
            <h6>{equipmentDetailsData?.gatewayNo || '-'}</h6>
          </div>

          <div className="equipment_information-content-data-item">
            <h5>Registered On</h5>
            <h6>
              {equipmentDetailsData?.registeredOn
                ? formatDate(equipmentDetailsData?.registeredOn)
                : '-'}
            </h6>
          </div>

          <div className="equipment_information-content-data-item">
            <h5>Manufactured On</h5>
            <h6>
              {equipmentDetailsData?.createdAt
                ? formatDate(equipmentDetailsData?.createdAt)
                : '-'}
            </h6>
          </div>

          <div className="equipment_information-content-data-item">
            <h5>Last Modification</h5>
            <h6>
              <h6>
                {equipmentDetailsData?.updatedAt
                  ? formatDate(equipmentDetailsData?.updatedAt)
                  : '-'}
              </h6>
            </h6>
          </div>

          <div className="equipment_information-content-data-item">
            <h5>Category</h5>
            <h6>{equipmentDetailsData?.category || '-'}</h6>
          </div>

          <div className="equipment_information-content-data-item">
            <h5>Sub Category</h5>
            <h6>{equipmentDetailsData?.subCategory || '-'}</h6>
          </div>

          <div className="equipment_information-content-data-item">
            <h5>Equipment type</h5>
            <h6>{equipmentDetailsData?.equipmentType || '-'}</h6>
          </div>


        <div className="equipment_information-content-data-item">
            <h5>Sim Number</h5>
            <h6>{equipmentDetailsData?.simNumber?equipmentDetailsData?.simNumber:"N/A" }</h6>
          </div>
          {/* <div className="equipment_information-content-data-item">
            <h5>Manufactured By</h5>
            <h6>{equipmentDetailsData?.manufacturedBy || '-'}</h6>
          </div> */}
        </div>
      </div>
    </section>
  );
};

const MemoizedComponent = React.memo(EquipmentInformation);
export default MemoizedComponent;
